import ContentBoxContainer from './ContentBoxContainer';

export default ContentBoxContainer;
